import { useMemo } from "react";
import { MediaItem } from "@/types/media";
import { MAX_IMAGES_PER_UPLOAD, MAX_VIDEOS_PER_UPLOAD } from "@/constants/media";

export function useHasReachedUploadLimit(orderedMediaItems: MediaItem[]): boolean {
    return useMemo(() => {
        const videoCount = orderedMediaItems.filter((item) => item.isVideo).length;
        const imageCount = orderedMediaItems.filter((item) => !item.isVideo).length;
        return videoCount >= MAX_VIDEOS_PER_UPLOAD || imageCount >= MAX_IMAGES_PER_UPLOAD;
    }, [orderedMediaItems]);
}
